import { Switch, TextField, Typography } from "@mui/material";
import type { OnboardingAnswers } from "../../types/onboarding";

export function SwitchCard({ title, hint, checked, onChange, children }: {
  title: string;
  hint: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  children?: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-3 rounded-xl border border-gray-200 p-4 dark:border-gray-800">
      <div className="flex items-center justify-between gap-4">
        <div>
          <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>{title}</Typography>
          <Typography variant="body2" color="text.secondary">{hint}</Typography>
        </div>
        <Switch checked={checked} onChange={(e) => onChange(e.target.checked)} slotProps={{ input: { role: "switch", "aria-label": title } }} />
      </div>
      {checked && children}
    </div>
  );
}

export default function ServicesSection({ answers, set }: {
  answers: OnboardingAnswers;
  set: (patch: Partial<OnboardingAnswers>) => void;
}) {
  return (
    <>
      <SwitchCard
        title="Alerts" hint="Pre-chargeback alerts on Ethoca, Verifi CDRN and RDR. Adds enrolments, refunds and go-live steps."
        checked={answers.alerts.enabled} onChange={(enabled) => set({ alerts: { enabled } })}
      />
      <SwitchCard
        title="Chargeback representment" hint="We fight chargebacks with evidence on every processor the brands use."
        checked={answers.representment} onChange={(representment) => set({ representment })}
      />
      <TextField
        label="Add-ons and agreed service levels" value={answers.addOns} multiline minRows={3} fullWidth
        onChange={(e) => set({ addOns: e.target.value })}
      />
    </>
  );
}
